import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_PAYMENT_METHOD_FOR_SECURITY_PROFILE,
  CLEAR_PAYMENT_METHODS_FOR_SECURITY_PROFILES,
  FLAG_GETTING_PAYMENT_METHODS_FOR_SECURITY_PROFILES,
  FLAG_PAYMENT_METHOD_FOR_SECURITY_PROFILE_ACTIVITY,
  GET_PAYMENT_METHOD_FOR_SECURITY_PROFILE,
  GET_PAYMENT_METHODS_FOR_SECURITY_PROFILES,
} from '../../../actions/types/security/PaymentMethodForSecurityProfile';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_PAYMENT_METHODS_FOR_SECURITY_PROFILES:
      return state.setIn(['all', 'loading'], payload);
    case GET_PAYMENT_METHODS_FOR_SECURITY_PROFILES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_PAYMENT_METHODS_FOR_SECURITY_PROFILES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_PAYMENT_METHOD_FOR_SECURITY_PROFILE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_PAYMENT_METHOD_FOR_SECURITY_PROFILE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_PAYMENT_METHOD_FOR_SECURITY_PROFILE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
